import React from "react";
import { FaIcon } from '../common/Icons.jsx';
import { truncateFilename } from './helpers.js'
import dayjs from 'dayjs';

const NOTIFICATION_STATUS_CLASS = {
  completed: null,
  in_progress: null,
  waiting: null,
  queued: null,
  failed: 'text-danger'
}

const EXTENSION_ICON_MAP = {
  'xlsx': 'file-excel',
  'pdf': 'file-lines',
  'zip': 'file-zipper'
}

const PROGRESS_BY_STATUS = {
  completed: null,
  in_progress: ({progress}) => <ProgressBar progress={progress} color="#4cb6b2" showBadge={true}/>,
  waiting: ({}) => <ProgressBar progress={1} color="#C1C1C1" />,
  queued: ({}) => <ProgressBar progress={1} color="#C1C1C1" />,
  failed: null,
}

const NoBorderButton = ({children, className = '', ...rest}) => <button className={'no-border-button ' + className} {...rest}>{children}</button>

const ProgressBar = ({color, progress, showBadge = false}) => {
  return <div
  className="progress"
  style={{
    margin: 0,
    borderRadius: "7px",
    backgroundColor: "#dbf0f0",
    height: "8px"
  }}
  >
  <div
    className="progress-bar animation-pulse"
    style={{
      width: `${progress * 100}%`,
      backgroundColor: color,
    }}
  >
  </div>

  {showBadge && <small style={{ position: "absolute", right: 70, marginTop: -3 }}>
    {(progress * 100).toFixed(0)}%
  </small>}
</div>
}

const NotificationProgress = (props) => {
  let Comp = PROGRESS_BY_STATUS[props.status]

  if (Comp) return <Comp {...props} />
  return null;
}

export const NoTaskNotifications = () => <div
  key='no-notifications'
  style={{
    borderLeftColor: "#F1F1F1", 
    background: "#F1F1F1",
    cursor: 'pointer',
    padding: '1rem',
    minWidth: 'max(30vw, 300px)'
  }}
>
  <span className='text-muted'>{I18n.t('no_long_running_tasks')}</span>
</div>



const FILE_TYPES = ['file_download', 'external_file_download'];


const resolveNotificationName = (notification) => {
  if (notification.name) return truncateFilename(notification.name, 40);
 
  if (I18n.t(notification.task_type) !== notification.task_type) {
    return I18n.t(notification.task_type)
  }
  return `${notification.id}`
}

const resolveIcon = (notification) => {
  if (notification.name) {
    const [extension] = notification.name.split('.').slice(-1);
    return EXTENSION_ICON_MAP[extension] || 'file-o';
  }
  return 'file-o'
}

export default function TaskNotification({
  index, 
  notification, 
  handleMarkAsRead, 
  handleDeleteClick, 
  noBorder,
  handleRetryClick,
  mayRetryTasks
}) {
  return <div
    key={index}
    style={{
      borderLeft: '0.5rem solid',
      borderColor: notification.read ? "#ccc" : "#f0ad4e", 
      background: notification.read ? "#F1F1F1" : "#FFF",
      cursor: 'pointer'
    }}
  >
    <div 
      className="justify-content-space-between hover-visibility-toggle" 
      style={{
        gap: '2rem',
        borderBottom: noBorder ? '' : '1px solid #CCC',
        padding: '0.5rem',
        display: 'grid', 
        gridTemplateColumns: 'auto 80px'
      }}
      onClick={(e) => handleMarkAsRead(e, index, notification)}
    >
      <div className='d-flex' style={{gap: '1.5rem'}}>
        <div className='d-flex align-items-center justify-content-center' style={{marginLeft: '1rem'}}>
          <FaIcon type={resolveIcon(notification)} style={{fontSize: 25, fontWeight: 400}} />
        </div>
        <div 
          className="d-flex flex-dir-column" 
          style={{
            gap: '0.25rem', 
            width: '100%',
            minWidth: 'min(30vw, 300px)'
          }}
        >
          <div style={{fontWeight: 500}} {...(notification.name ? {title: notification.name} : {})}>
            {resolveNotificationName(notification)}
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <small className="text-muted d-flex" style={{gap: '0.5rem'}}>
              <span>{dayjs(notification.updated_at).format(
                programmeSettings("datetime-format")
              )}
              </span>
              <span>|</span>
              <span className={NOTIFICATION_STATUS_CLASS[notification.status]}>
                {I18n.t(notification.status, {position: 0})}
              </span>
            </small>
          </div>
          <NotificationProgress progress={notification.progress} status={notification.status} queuePosition={0}/>
        </div>
      </div>
      

          {["completed", "failed"].includes(notification.status) && (
            <div className="d-flex" style={{gap: '0.5rem', justifyContent: 'flex-end', alignItems: 'center'}}>
              {notification.status == 'failed' && notification.resumable && (
                <div className="d-flex" style={{gap: '0.2rem', justifyContent: 'flex-end'}}>
                  <NoBorderButton
                    onClick={(e) => {handleRetryClick(e, index, notification)}}
                    title= {I18n.t("retry")}
                    className='text-info'
                    style={{width: 35, height: 35}}
                  >
                    <FaIcon type='repeat'/>
                  </NoBorderButton>
                </div>
              )}
              {notification.status === "completed" &&
                FILE_TYPES.includes(notification.task_type) && (
                  <a 
                    href={notification.result} 
                    download={notification.name}
                    className='no-border-button text-primary'
                    title={I18n.t("download")}
                    style={{width: 35, height: 35}}
                  >
                    <FaIcon type='download' />
                  </a>
                )}
              <NoBorderButton
                onClick={(e) => {handleDeleteClick(e, index, notification)}}
                title= {I18n.t("delete")}
                className='text-danger'
                style={{width: 35, height: 35}}
              >
                <FaIcon type='trash'/>
              </NoBorderButton>
            </div>
          )}

    </div>
  </div>
};